// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --checkboxSize: 1.125rem;
  --focusOutlineFF: 2px auto Highlight;
  --focusOutline: 2px auto -webkit-focus-ring-color;
  --focusOutlineOffset: 4px;
  --focusOutlineOffsetFF: 2px;
  --inputLineColor: var(--colorGrey40);
  --inputLabelColor: var(--colorGrey40);
  --inputIconWidth: 1.875rem;
  --inputBorderWidth: 2px;
  --inputEasingFn: ease;
  --inputTransitionTime: 0.28s;
  --selectHeight: 3rem;
}

:root {
  --selectLeftIconTopAdjustment: 14px;
  --selectLeftIconValueAdjustment: 4px;
  --selectLeftIconOpenedLabelAdjustment: 5px;
}

.select__item {
    height: 3rem;
    padding: 0 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 400;
    line-height: 3rem;
    white-space: nowrap;
    cursor: pointer;
    border-bottom: 0.0625rem solid #f6f7f8;
  }

.select__item:hover,
    .select__item--hover {
      background: #f6f7f8;
    }

.select__item:hover .user-select__user-icon, .select__item--hover .user-select__user-icon {
        color: #206dd2;
      }

.select__item--selected,
    .select__item--selected:hover {
      font-weight: 700;
      background: #e5f5ff;
    }

.select__item--thick-border-bottom:not(:last-of-type) {
      border-bottom-color: #d4d4d4;
    }

.select--hide-label {
    margin-top: 0;
  }

.select--hide-label .select__label {
      display: none;
    }

.select--hide-label .select__value-container {
      margin-top: 0;
    }

.select__button {
    opacity: 1;
  }

.select__value {
    padding-left: calc(.25rem);
  }

.select--clearable.select--has-clear-value .select__value {
        padding-right: calc(3rem);
      }

.select--clearable.select--has-clear-value .select__clear-button {
        right: calc(1.5rem);
      }

.select--clearable .select__clear-button {
      position: absolute;
      top: calc(.5rem);
      z-index: 2;
      width: calc(1.5rem);
      height: calc(1.5rem);
      padding: 0;
      color: #707070;
      cursor: pointer;
      background-color: transparent;
      border: none;
    }

.select.input.input--icon .select__button {
      margin-left: 1.875rem;
    }

.select.input.input--icon .select__opened-label {
      margin-top: 5px;
      margin-left: 1.875rem;
    }

.select.input.input--icon .select__value {
      padding-left: calc(2.125rem - 4px);
    }

.select.input.input--icon .select__label {
      top: 0;
      left: 1.875rem;
      padding: 0.875rem 0 0.4375rem 0;
      font-weight: 400;
      color: #707070;
      text-transform: none;
      font-size: 1rem;
      line-height: 1.5rem;
    }

.select.input.input--icon.select--has-value .select__label,
    .select.input.input--icon.select--menu-open .select__label {
      top: -0.25rem;
      left: 0;
      padding: 0;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.375rem;
      color: #707070;
      text-transform: uppercase;
      left: 0;
    }

.select__left-icon {
    top: 14px;
  }
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
